import { v4 as uuidv4 } from 'uuid';
import { API_ENDPOINTS } from '../config/api';

function getAdminHeaders() {
  let creds = {};
  try {
    creds = JSON.parse(sessionStorage.getItem('adminAuth')) || {};
  } catch (e) {
    creds = {};
  }
  return {
    'Content-Type': 'application/json',
    'x-admin-login': creds.login || '',
    'x-admin-password': creds.password || '',
  };
}

function handleUnauthorized() {
  localStorage.removeItem('isAuthenticated');
  sessionStorage.removeItem('adminAuth');
  window.location.reload();
}

async function parseResponse(res) {
  const text = await res.text();
  let body = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch (e) {
    body = { error: 'invalid_response', details: text };
  }

  if (res.status === 401) {
    handleUnauthorized();
    const err = new Error('unauthorized');
    err.code = 'unauthorized';
    throw err;
  }

  if (!res.ok) {
    const err = new Error((body && (body.error || body.message)) || `Request failed: ${res.status}`);
    err.code = body?.error || 'request_failed';
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export async function lookupCustomer(query) {
  const res = await fetch(API_ENDPOINTS.employeeLoyalty.lookup, {
    method: 'POST',
    headers: getAdminHeaders(),
    body: JSON.stringify({ query }),
  });
  return parseResponse(res);
}

export async function adjustPoints({ cardNumber, brandKey, walletId, delta, comment, employeeName, idempotencyKey }) {
  const key = idempotencyKey || uuidv4();
  const res = await fetch(API_ENDPOINTS.employeeLoyalty.adjust, {
    method: 'POST',
    headers: getAdminHeaders(),
    body: JSON.stringify({ cardNumber, brandKey, walletId, delta, comment, employeeName, idempotencyKey: key }),
  });
  return parseResponse(res);
}

export function newIdempotencyKey() {
  return uuidv4();
}
